module.exports = __webpack_public_path__ + "static/Ausgov-5be2c188f8432dfff81487e9e985f5a2.svg";